module.exports = __webpack_public_path__ + "public/SiteImages/playStore.png?ab58b5fe";